import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Pais } from './paises.model';

@Injectable({
  providedIn: 'root'
})
export class PaisesService {
  url: string;

  constructor(private http: HttpClient) {}

  getPaises(): Observable<Pais[]> {
    console.log(this.url);
    return this.http.get<Pais[]>(`${this.url}/paises/`);
  }
}
